var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMateData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1706511587514,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8865,
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M923.744 853.344a32 32 0 0 1 32 32v4.256a32 32 0 0 1-32 32H100.256a32 32 0 0 1-32-32v-4.256a32 32 0 0 1 32-32h823.488z m-614.4-477.888a32 32 0 0 1 32 32V787.2a32 32 0 0 1-32 32h-140.8a32 32 0 0 1-32-32V407.456a32 32 0 0 1 32-32h140.8z m546.112 102.4a32 32 0 0 1 32 32V787.2a32 32 0 0 1-32 32h-140.8a32 32 0 0 1-32-32v-277.344a32 32 0 0 1 32-32h140.8z m-273.056-307.2a32 32 0 0 1 32 32V787.2a32 32 0 0 1-32 32h-140.8a32 32 0 0 1-32-32V202.656a32 32 0 0 1 32-32h140.8z m-305.088 268.8h-76.8V755.2h76.8v-315.744z m546.144 102.4h-76.8V755.2h76.8v-213.344z m-273.056-307.2h-76.8V755.2h76.8V234.656z",
    fill: "#bfbfbf",
    "p-id": 8866
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMateData);
export default __webpack_public_path__ + "static/media/Menu_MateData.1970c9712739aeb62236999e679970ed.svg";
export { ForwardRef as ReactComponent };